import { render, staticRenderFns } from "./SeparationAnxietyInstructionsCard.vue?vue&type=template&id=30600544&scoped=true&"
import script from "./SeparationAnxietyInstructionsCard.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyInstructionsCard.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyInstructionsCard.vue?vue&type=style&index=0&id=30600544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30600544",
  null
  
)

export default component.exports